
<!--
 * @Description: 添加课件
 * @Author: 王赵坤
 * @Date: 2022-10-28 17:32:04
 * @LastEditors: PF
 * @LastEditTime: 2025-06-17 17:55:42
-->
<template>
  <div class="list-page pl0 pt0 pr0 pb0">
    <el-container>
      <el-main>
        <el-form ref="ruleFormRef" :model="ruleForm" label-width="80px" class="demo-ruleForm" status-icon>
          <el-row>
            <el-col :span="12">
              <el-form-item label="学期:">
                <span>{{xqmc}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程:">
                {{kcmc}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="周次:">
                <span>第{{zc}}周</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="班级/节次:" class="bjjc">
                <el-row>
                  <el-col :span="12" v-for="item in chechboxtrue" :key="item.id">
                    <div style="width:300px">
                      <span>{{item.bjmc}}/星期{{week[item.xq]}}第{{item.jc}}节</span>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教学单元" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.jxdyid" @change="danDuanChange" style="width: calc(100% - 70px);">
                  <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
                </el-select>
                <el-button type="primary" @click="openAddJiaoXueDanYuan=true;row={kcid:kcid,kcmc:bjlist[0].kcmc}">添加</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教学内容" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.jxnrid" style="width: calc(100% - 70px);">
                  <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
                </el-select>
                <el-button type="primary" @click="openAddJiaoXueNeiRong=true;row={kcid:kcid,kcmc:bjlist[0].kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传视频">
                <el-upload class="upload-demo" style="width:100%;" :show-file-list="false" drag :http-request="importspClick">
                  <el-icon class="el-icon--upload">
                    <upload-filled />
                  </el-icon>
                  <div class="el-upload__text">
                    将文件拖到此处，或 <em>点击上传</em>
                  </div>
                </el-upload>
                <div class="fujian" v-for="(item,index) in sps" :key="item.showPath">
                  <el-link :href="baseurl+item.showPath" target="_blank" type="primary">{{item.oldname}}</el-link>
                  <el-link @click="shipindel(index)"><span class="iconfont icon-shanchu"></span></el-link>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件" prop="fj">
                <el-upload style="width:100%" class="upload-demo" drag :show-file-list="false" accept=".pdf" :http-request="importClick">
                  <el-icon class="el-icon--upload">
                    <upload-filled />
                  </el-icon>
                  <div class="el-upload__text">
                    将文件拖到此处，或 <em>点击上传</em>
                  </div>
                </el-upload>
                <div class="fujian" v-for="(item,index) in fjs" :key="item.showPath">
                  <el-link :href="baseurl+item.showPath" target="_blank" type="primary">{{item.oldname}}</el-link>
                  <el-link @click="fuJianDel(index)"><span class="iconfont icon-shanchu"></span></el-link>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-main>
      <el-footer class="el-dialog__footer">
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" v-if="sfwcbc" @click="submit()">保存 </el-button>
            <el-button type="primary" v-if="sfwctj" @click="submitTj()">保存并提交</el-button>
            <el-button @click="handleClose">关闭</el-button>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="keChengChange" />
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="row" @ReturnData="danDuanChange" />
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import { successPrompt } from '@/utils/promptInfo'
import { UploadFilled } from '@element-plus/icons-vue'
import { uploadV2 } from '@/api/publicApi'
import jiaoxuedanyuan from './jiaoxuedanyuan.vue'
import jiaoxueneirong from './jiaoxueneirong.vue'
import { closeWindow, loadSelect, submitForm } from '@/api/common.js'
const props = defineProps({
  openAdd: {
    type: Boolean,
    required: true
  },
  row: {
    type: Object,
    required: false
  },
  chechboxtrue: {
    type: Array,
    required: false
  }
})
const ruleFormRef = ref(null)
const ruleForm = ref({})
const bjlist = ref()
// const jxsjmb = ref()// 模板内容
const baseurl = ref(process.env.VUE_APP_BASE_API)
const xqid = ref()
const xqmc = ref()
const kcid = ref()
const kcmc = ref()
const zc = ref()
const fjs = ref([]) // 附件
const sps = ref([]) // 视频
const jxnrData = ref([])
const jxdyData = ref([])
const openAddJiaoXueDanYuan = ref() // 添加教学单元
const openAddJiaoXueNeiRong = ref() // 添加教学内容
const row = ref()
const emits = defineEmits(['update:openAdd', 'ReturnData', 'guanBi'])

// 关闭
const handleClose = () => {
  closeWindow('openAdd', emits, true)
  emits('update:openAdd', true)
  emits('guanBi', true)
}
const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])
// 选择课程
const keChengChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: {
      kcid: props.row.chechboxtrue[0].kcid,
      order: 'sx',
      sort: 'asc'
    }
  })
}
// 选择教学单元
const danDuanChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    data: jxnrData,
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
  })
}
// 删除视频
const shipindel = (ind) => {
  sps.value.splice(ind, 1)
}
// 删除附件
const fuJianDel = (ind) => {
  fjs.value.splice(ind, 1)
}

// 上传视频
const importspClick = async (file) => {
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'jiaoxveshejikejian') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  uploadV2(formData)
    .then((res) => {
      const obj = {
        oldname: res.data.ymc,
        showPath: res.data.lj + res.data.mc,
        id: res.data.id
      }
      sps.value.push(obj)
      successPrompt('上传成功')
    })
    .catch()
}
// 上传文件
const importClick = async (file) => {
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'jiaoxveshejikejian') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  uploadV2(formData)
    .then((res) => {
      const obj = {
        oldname: res.data.ymc,
        showPath: res.data.lj + res.data.mc,
        id: res.data.id
      }
      fjs.value.push(obj)
      successPrompt('上传成功')
    })
    .catch()
}
const dbgzid = ref()
watch(
  () => props.chechboxtrue,
  () => {
    if (props.chechboxtrue) {
      bjlist.value = props.chechboxtrue
    }
  },
  { deep: true, immediate: true }
)
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      xqmc.value = props.row.xqmc
      xqid.value = props.row.xqid
      zc.value = props.row.zc
      kcid.value = props.row.chechboxtrue[0].kcid
      kcmc.value = props.row.chechboxtrue[0].kcmc
      dbgzid.value = props.row.chechboxtrue[0].id
      keChengChange()
    }
  },
  { deep: true, immediate: true }
)

// 保存
const sfwcbc = ref(true)
const sfwctj = ref(true)
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const data = {
    kbid: bjlist.value[0].id,
    xqid: props.row.xqid,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    listFj: [
      {
        fjlx: 1,
        fjs: sps.value.map((item) => {
          return item.showPath
        })
      },
      {
        fjlx: 2,
        fjs: fjs.value.map((item) => {
          return item.showPath
        })
      }
    ],
    zc: props.row.zc,
    bjid: bjlist.value[0].bjid,
    jc: bjlist.value[0].jc,
    kcid: kcid.value,
    xq: bjlist.value[0].xq,
    dbgzid: bjlist.value[0].id,
    jxsjbjcks: bjlist.value.map(item => ({
      kbid: item.id,
      bjid: item.bjid,
      jc: item.jc,
      kcid: item.kcid,
      xq: item.xq
    })),
    zt: 0
  }
  submitForm({
    url: '/api/v2/jiaowu/jiaowukejian',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: data,
    callback: function () {
      ruleForm.value = {}
      sps.value = []
      fjs.value = []
      sfwcbc.value = false
    }
  })
}
// 保存并提交
const submitTj = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const data = {
    kbid: bjlist.value[0].id,
    xqid: props.row.xqid,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    listFj: [
      {
        fjlx: 1,
        fjs: sps.value.map((item) => {
          return item.showPath
        })
      },
      {
        fjlx: 2,
        fjs: fjs.value.map((item) => {
          return item.showPath
        })
      }
    ],
    zc: props.row.zc,
    bjid: bjlist.value[0].bjid,
    jc: bjlist.value[0].jc,
    kcid: kcid.value,
    xq: bjlist.value[0].xq,
    dbgzid: bjlist.value[0].id,
    jxsjbjcks: bjlist.value.map(item => ({
      kbid: item.id,
      bjid: item.bjid,
      jc: item.jc,
      kcid: item.kcid,
      xq: item.xq
    })),
    zt: 1
  }
  submitForm({
    url: '/api/v2/jiaowu/jiaowukejian',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: data,
    callback: function () {
      ruleForm.value = {}
      sps.value = []
      fjs.value = []
      sfwcbc.value = false
      sfwctj.value = false
    }
  })
}
</script>
<style lang="less" scoped>
.fujian {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.bjjc {
  width: 100%;
}
</style>
